import landing1 from "@/assets/landing-1.svg";
import landing2 from "@/assets/landing-2.svg";
import { Box, styled } from "@mui/material";

const PILOT_PORTAL_URL = import.meta.env.VITE_PILOT_PORTAL_URL;
const PROGRAM_PORTAL_URL = import.meta.env.VITE_PROGRAM_PORTAL_URL;

export const programs = [
  {
    title: "2024 Solar Battery Savings Pilot",
    description:
      "Contractors may log in to manage or complete existing projects only.",
    image: landing1,
    buttonLabel: "Open Portal",
    url: PILOT_PORTAL_URL,
    status: "Not accepting new applications",
    statusColor: "#E0E0E0",
    statusTextColor: "#333",
  },
  {
    title: "2025 Solar Battery Savings Program",
    description:
      "Start a new project or continue work on existing applications.",
    image: landing2,
    buttonLabel: "Open Portal",
    url: PROGRAM_PORTAL_URL,
    status: "Accepting new applications",
    statusColor: "#1565c0",
    statusTextColor: "#fff",
  },
];

export const CARD_RADIUS = 12;
export const CARD_ASPECT_RATIO = 16 / 7;
export const OVERLAY_HEIGHT = 100;

export const Card = styled(Box)(() => ({
  position: "relative",
  width: "100%",
  aspectRatio: `${CARD_ASPECT_RATIO}`,
  borderRadius: CARD_RADIUS,
  overflow: "hidden",
  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
  background: "#eee",
  minHeight: 360,
  maxHeight: 520,
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "center",
}));

export const CardImage = styled("img")(() => ({
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  objectFit: "cover",
  borderRadius: CARD_RADIUS,
  zIndex: 1,
  pointerEvents: "none",
  userSelect: "none",
}));

export const CardOverlay = styled(Box)(() => ({
  position: "absolute",
  left: 16,
  right: 16,
  bottom: 24,
  background: "rgba(255,255,255,0.92)",
  borderRadius: CARD_RADIUS,
  boxShadow: "0 2px 12px rgba(0,0,0,0.10)",
  padding: "14px",
  zIndex: 2,
  display: "flex",
  flexDirection: "column",
  gap: 8,
  minWidth: 0,
  alignItems: "flex-start",
  height: "130px",
  justifyContent: "center",
}));

export const StatusChip = styled(Box, {
  shouldForwardProp: (prop) => prop !== "variant",
})<{ variant?: "filled" | "outlined" }>((props) => ({
  background: props.variant === "filled" ? "#1565c0" : "transparent",
  color: props.variant === "filled" ? "#fff" : "#5A6376",
  border: props.variant === "filled" ? "none" : "1px solid #B0B7C3",
  borderRadius: "6px",
  padding: "4px 16px",
  fontSize: 12,
  fontWeight: 500,
  display: "inline-block",
  marginBottom: 14,
}));

export const OverlayRow = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  width: "100%",
  gap: 16,
  justifyContent: "space-between",
}));
